import { config } from "zod";

export function configureValidationRuntime() {
  config({ jitless: true });
}
